import { getAccessToken, removeTokens } from "./token";
import { getLocaleFromSearchParams } from "./translation";
import { getWhiteLabel } from "./white-label";

export const getLoginUrl = () => {
  const encodedPathWithSearch = encodeURIComponent(
    window.location.pathname + window.location.search,
  );
  const locale =
    getLocaleFromSearchParams()?.replace("_", "-").toLowerCase() ?? "en-us";

  const url = new URL(window.location.href);
  url.search = `?returnPath=${encodedPathWithSearch}`;
  url.pathname = `/${locale}/user/login/`;
  return url.href;
};

export const redirectToLogin = () => {
  window.location.href = getLoginUrl();
};

export const handleAuthCheck = () => {
  if (!getAccessToken() && getWhiteLabel().authRequired) {
    removeTokens();
    redirectToLogin();
  }
};
